import 'bootstrap/dist/css/bootstrap.min.css';

import Svg_YolYardim from '../assets/img/svg/yolyardim_svg.svg';
import Svg_Cekici from '../assets/img/svg/car_ico.svg';
import Svg_IkameArac from '../assets/img/svg/ikamearac_svg.svg';
import Svg_Assistance from '../assets/img/svg/svg_hizmet.svg';
import Svg_CagriMerkezi from '../assets/img/svg/cagrimerkezi_svg.svg';
import Svg_KisiyeOzel from '../assets/img/svg/kisiyeozel_svg.svg';

function Hizmetlerimiz() {
    const serviceCards = [
        {
            icon: Svg_YolYardim,
            title: 'Yol Yardım',
            description:
                'Araç arızası, lastik problemi, yakıt veya akü desteği gibi tüm acil durumlarda 7/24 profesyonel ekibimize ulaşın.',
            link: '/tr/hizmetlerimiz/yol-yardim-kurtarma-hizmeti',
            iconBg: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            delay: 200,
        },
        {
            icon: Svg_Cekici,
            title: 'Çekici & Oto Kurtarma',
            description:
                'Kaza, arıza veya güvenli olmayan yol koşullarında aracınızı en yakın servis noktasına güvenle taşıyan çekici ve kurtarma hizmetimizi keşfedin.',
            link: '/tr/hizmetlerimiz/cekici-hizmeti',
            iconBg: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            delay: 300,
        },
        {
            icon: Svg_IkameArac,
            title: 'İkame Araç Hizmeti',
            description:
                'Aracınız servisteyken ulaşımınızın aksamaması için segment seçeneğiyle sunulan ikame araç çözümlerimizden hemen yararlanın.',
            link: '/tr/hizmetlerimiz/ikame-arac-hizmeti',
            iconBg: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            delay: 400,
        },
        {
            icon: Svg_Assistance,
            title: 'Assistance Altyapı Hizmeti',
            description:
                'Sigorta acentelerine özel, çağrı merkezi + yazılım + operasyon + hizmet ağı içeren entegre assistance altyapımızla kendi markanızı kurun.',
            link: '/tr/hizmetlerimiz/asistans-altyapi-cozumleri',
            iconBg: 'linear-gradient(135deg, #80909C 0%, #A1BCD1 100%)',
            delay: 500,
        },
        {
            icon: Svg_CagriMerkezi,
            title: '7/24 Çağrı Merkezi Yönetimi',
            description:
                'Müşterilerinizin tüm assist hizmeti taleplerini profesyonel ekiplerimizin bulunduğu, kesintisiz çağrı merkezi altyapımız ile yönetin.',
            link: '/tr/hizmetlerimiz/cagri-merkezi-hizmeti',
            iconBg: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            delay: 600,
        },
        {
            icon: Svg_KisiyeOzel,
            title: 'Kişiye Özel Paketler',
            description:
                'Sürücü ihtiyaçlarına göre tasarlanan, esnek ve kapsamlı kişiye özel paketlerimizi inceleyerek sizin için en uygun çözümü seçin.',
            link: '/tr/hizmetlerimiz/kisiye-ozel-hizmet-paketleri',
            iconBg: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            delay: 700,
        },
    ];

    return (
        <>
            <section className="standard-section">
                <div className="standard-container">
                    <div className="standard-section-title">
                        <div
                            className="standard-section-title__sub-title"
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            HİZMETLERİMİZ
                        </div>
                        <div
                            className="standard-section-title__main"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <p className="standard-section-title__main--desc">
                                Kapsamlı Asistans hizmetlerimizle ihtiyaç duyduğunuz her an
                                yanınızdayız
                            </p>
                        </div>
                    </div>

                    <div className="row g-4">
                        {serviceCards.map((card, index) => (
                            <div
                                key={index}
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-delay={card.delay}
                            >
                                <div className="elegant-stats-card">
                                    <div className="elegant-stats-card__header">
                                        <div
                                            className="elegant-stats-card__icon"
                                            style={{ background: card.iconBg }}
                                        >
                                            <img
                                                src={card.icon}
                                                alt={card.title}
                                                className="elegant-icon-image"
                                            />
                                        </div>
                                        <div className="elegant-stats-card__decoration-line"></div>
                                    </div>
                                    <div className="elegant-stats-card__body">
                                        <div className="elegant-stats-card__title">
                                            {card.title}
                                        </div>
                                        <div className="elegant-stats-card__description">
                                            {card.description}
                                        </div>
                                        <div className="mt-3">
                                            <a
                                                href={card.link}
                                                className="c-button c-button--border"
                                            >
                                                DETAYLI BİLGİ
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Hizmetlerimiz;
